import { render, staticRenderFns } from "./SearchByCadastre.vue?vue&type=template&id=2a63ff0e"
import script from "./SearchByCadastre.vue?vue&type=script&lang=ts"
export * from "./SearchByCadastre.vue?vue&type=script&lang=ts"
import style0 from "./SearchByCadastre.vue?vue&type=style&index=0&id=2a63ff0e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports